import { useEffect, useRef, useState } from "react";

/** Mounts children only once the placeholder scrolls near the viewport (saves WebGL/map work). */
export const LazyMount = ({ className = "", children, rootMargin = "300px" }) => {
  const ref = useRef(null);
  const [show, setShow] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el || show) return undefined;
    const io = new IntersectionObserver(([entry]) => entry.isIntersecting && setShow(true), { rootMargin });
    io.observe(el);
    return () => io.disconnect();
  }, [show, rootMargin]);
  return <div ref={ref} className={className}>{show ? children : <div className="h-full w-full animate-pulse bg-neutral-100" />}</div>;
};
